//import  baseHttp  from '@/services/baseHttp';

// initial state
// put variables and collections here
const state = () => ({
  mondayInfo:{mondayMetaObj:null,locationData:null,item:null,credentials:null,userInfo:null,user:null,ticket:null,origin:null,app_guid:null,attachments:[],linkedItems:[]},
  mdTicket:null,
  mdTicket_fields:null,
  mdMetadata:null,
})

// getters
const getters = {
  getMondayInfo(state){
    return state.mondayInfo;
  },
  getMdTicket(state){
    return state.mdTicket;
  },
  getMdTicket_fields(state){
    return state.mdTicket_fields;
  },
  getMondayMetadata(state){
    return state.mdMetadata;
  }
}

// actions
// put asynchronous functions that can call one or more mutation functions
//https://developer.mondayClient.com/apps/docs/core-api/client_api
const actions = {
  async getMondayMetadata(context){
    // let sessionData = await mondayClient.get("sessionToken");
    // console.log('monday sessionData1 ',sessionData);

    //let settingsData = await mondayClient.get("settings"); //returns blank data as of now
    let contextData = await mondayClient.get("context");
    //console.log('mondayContextObj ',contextData);
    context.commit('setMondayMetadata', contextData.data); 
    return contextData;
  },
  async getMondayInfo(context) {
    
    let mondayInfo={};
    
    let mondayMetaObj = await actions.getMondayMetadata(context);
    //console.log('mondayMetaObj ',mondayMetaObj);
    mondayMetaObj = mondayMetaObj.data;
    let isViewOnly = mondayMetaObj.user.isViewOnly;
    //let requestType = document.location.pathname;
  
    //requestType=requestType.startsWith('/')?requestType.substr(1,requestType.length-1):requestType;
    //requestType=requestType.endsWith('/')?requestType.substr(0,requestType.length-1):requestType;
    mondayInfo.credentials = { requestType: "monday-devops" };
  
    //it will return https://d3v-devopsintegration.mondayClient.com
    //mondayInfo.credentials.hdLoginUrl=document.location.ancestorOrigins[0];

    let locationData = await mondayClient.get("location");
    //console.log('locationData ', locationData);
  
    mondayInfo.mondayMetaObj = mondayMetaObj;
    mondayInfo.locationData = locationData;

    let currentItemURL = locationData.data.href;
    let hdLoginUrl = currentItemURL.split('/boards')[0];

    let boardId = mondayMetaObj.boardId;// currentItemURL.split('/')[currentItemURL.split('/').indexOf('boards') + 1];
    let itemId = mondayMetaObj.itemId;// currentItemURL.split('/')[currentItemURL.split('/').length - 1];
    if (isViewOnly == false) {
      //let item=await mondayClient.api(`query { items (ids: [${itemId}]) { id,name,state }}`);
      let item = await mondayClient.api(`query { items(ids: [${itemId}]) { board { id },id,name,state,column_values { column { id title } id text type value}}}`);
      //let itemUpdates = await mondayClient.api(`query { items (ids: ${itemId}) { updates (limit: 1) { body id  created_at  creator { name id } }}}`);
      //itemUpdates = itemUpdates.data.items[0].updates;
      //console.log('item updates',itemUpdates.data.items[0].updates)
    
      
      mondayInfo.item = item.data.items[0];
      //mondayInfo.itemUpdates=itemUpdates.data.items[0].updates;
      let user = await mondayClient.api(`query { me { id name email is_admin is_guest created_at  account { name id }}}`);
      //console.log('mondayUserObj ',user);
      mondayInfo.user = user.data.me;
    
      mondayInfo.credentials.name = user.data.me.name;
      mondayInfo.credentials.email = user.data.me.email;
      mondayInfo.credentials.appId = mondayMetaObj.app.id;
      mondayInfo.credentials.installationId = mondayMetaObj.account.id;
    
      mondayInfo.credentials.hdLoginUrl = hdLoginUrl
      mondayInfo.credentials.hdBrandLoginUrl = hdLoginUrl;
      //console.log('currentUser',mondayInfo.user)
      //console.log('currentItem',mondayInfo.item);
      
    }
      context.commit('setMondayInfo', mondayInfo);
  },
  async getMdTicket(context) {
    let locationData = await mondayClient.get("location");
    let currentItemURL = locationData.data.href;
    let itemId = currentItemURL.split('/')[currentItemURL.split('/').length - 1];

    //console.log('i am on this ticket');
    let item=await mondayClient.api(`query { boards(ids: ${boardId}) { columns {id,title,type}}}`);
    mdTicket = item.data;
    
    let itemUpdates = await mondayClient.api(`query { items (ids: ${itemId}) { updates (limit: 100) { body id  created_at  creator { name id } }}}`);
    mdTicket.itemUpdates = itemUpdates.data;
    
    context.commit('setMdTicket',mdTicket); 
  },
  async getMdTicket_fields(context) {
    let mdTicket_fields;

    let locationData = await mondayClient.get("location");
    let currentItemURL = locationData.data.href;
    let itemId = currentItemURL.split('/')[currentItemURL.split('/').length - 1];

    let itemFields=await mondayClient.api(`query { items(ids: [${itemId}]) { id,name,state,column_values { column { id title } id text type value}}}`);
    
    mdTicket_fields=itemFields.data;
    context.commit('setMdTicket_fields',mdTicket_fields); 
  },
}

// mutations
// put sychronous functions for changing state e.g. add, edit, delete
const mutations = {
  setMondayMetadata(state,payload){
    state.mdMetadata=payload;
  },
  setMondayInfo(state,payload){
    state.mondayInfo = payload;
    
    //state.mondayInfo.credentials.appId=state.mdMetadata.account.id;
    //state.mondayInfo.credentials.installationId=state.mdMetadata.account.id;
  },
  setMdTicket_fields(state,payload){
    state.mdTicket_fields=payload;
  },
  setMdTicket(state,payload){
    state.mdTicket=payload;
  },
  setMondayAttachments(state,payload){
    state.mondayInfo.attachments=payload;
  },
  setMondayLinkedItems(state,payload){
    state.mondayInfo.linkedItems=payload;
  },
  setMondayUser(state,payload){
    state.mondayInfo.userInfo=payload;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
